import { Box, Button } from '@mui/material';
import { useState } from 'react';
import AceEditor from 'react-ace';

import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/theme-monokai';
import 'ace-builds/src-noconflict/ext-language_tools';

export function ChatbotCodeComponent({ ...props }: any) {
  const match = /language-(\w+)/.exec(props.className ?? '');
  const isHtml = match?.[1] === 'html';

  const [isPreview, setIsPreview] = useState(false);

  if (!match) {
    return (
      <code className="bg-gray-200 text-sm px-1 py-0.5 rounded">
        {props.children}
      </code>
    );
  }

  return (
    <Box sx={{ position: 'relative' }}>
      {isHtml && (
        <Button
          size="small"
          onClick={() => setIsPreview(!isPreview)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            zIndex: 1,
            backgroundColor: 'rgba(0,0,0,0.1)',
            color: '#fff',
            '&:hover': {
              backgroundColor: 'rgba(0,0,0,0.2)',
            },
          }}
        >
          {isPreview ? 'Raw' : 'Preview'}
        </Button>
      )}

      {isPreview ? (
        <Box sx={{ width: '100%', minHeight: '400px' }}>
          <iframe
            srcDoc={String(props.children).replace(/\n$/, '')}
            title="Code Preview"
            sandbox="allow-scripts allow-same-origin"
            style={{
              minHeight: 'inherit',
              width: '100%',
              height: '100%',
              border: 'none',
              borderRadius: '8px',
              backgroundColor: '#fff',
            }}
          />
        </Box>
      ) : (
        <AceEditor
          mode="javascript"
          theme="monokai"
          name="chatbot-code"
          value={props.children}
          fontSize={14}
          style={{
            borderRadius: '8px',
            width: '100%',
          }}
          lineHeight={19}
          showGutter={true}
          highlightActiveLine={true}
          readOnly
          setOptions={{
            useWorker: false,
          }}
        />
      )}
    </Box>
  );
}
